var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.584 2.401c3.852 0 7.084 3.132 7.084 7.083a7.033 7.033 0 01-7.084 7.084 7.033 7.033 0 01-7.083-7.084c0-3.851 3.132-7.083 7.083-7.083zM23.761 21.89l-6.673-6.673c1.25-1.67 1.88-3.652 1.88-5.733C18.969 4.272 14.698 0 9.485 0 4.272 0 0 4.272 0 9.484c0 5.213 4.272 9.485 9.484 9.485 2.081 0 4.172-.73 5.833-1.981l6.673 6.673c.21.21.52.31.83.31.31 0 .63-.1.83-.31.2-.21.31-.52.31-.83.101-.42 0-.73-.21-.941"
  })));
}
export default SvgIconSearch24;